import { CannabisProvider } from 'Context/CannabisContext';
import { CannabisMain } from './CannabisMain';

export const Cannabis = () => (
  <CannabisProvider>
    <CannabisMain />
  </CannabisProvider>
);
